export default __webpack_public_path__ + "assets/14e4d7.png";